const BaseComponent = require('base/new_sameday_class');

module.exports = class a extends BaseComponent {};
